export default "__VITE_ASSET__c2adb932__"